import ShimmerLoader from '@components/ShimmerLoader/ShimmerLoader';

import styles from './BlinqImageEditor.module.scss';

interface ImageEditorLoaderProps {
  disableBgEdit?: boolean;
}
const Loader: React.FC<React.PropsWithChildren<ImageEditorLoaderProps>> = ({
  children,
  disableBgEdit,
  ...props
}) => {
  return (
    <div className={styles['image-editor-loader']}>
      <div className={styles['image-editor-loader-canvas']} {...props}></div>
      <div className={styles['image-editor-loader-controls-section']}>
        <div className={styles['image-editor-loader-zoom-control']} {...props}></div>
        {!disableBgEdit && (
          <div className={styles['image-editor-loader-background-control']} {...props}></div>
        )}
      </div>
      {children}
    </div>
  );
};
const ImageEditorLoader: React.FC<React.PropsWithChildren<ImageEditorLoaderProps>> = ({
  children,
  disableBgEdit,
}) => {
  return (
    <ShimmerLoader>
      {(props) => (
        <Loader disableBgEdit={disableBgEdit} {...props}>
          {children}
        </Loader>
      )}
    </ShimmerLoader>
  );
};

export default ImageEditorLoader;
